import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
  type FC,
  type ReactNode,
} from 'react';

import { getItem, setItem } from '../../../utils/localStorage';

const ATLAS_HOME_OPT_IN_KEY = 'infield-atlas-home-opt-in';

type AtlasHomeOptInContextValue = {
  isEnabled: boolean;
  setEnabled: (enabled: boolean) => void;
};

export const AtlasHomeOptInContext = createContext<
  AtlasHomeOptInContextValue | undefined
>(undefined);

export const AtlasHomeOptInProvider: FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [isEnabled, setIsEnabled] = useState(
    () => getItem(ATLAS_HOME_OPT_IN_KEY) === true
  );
  const setEnabled = useCallback((enabled: boolean) => {
    setItem(ATLAS_HOME_OPT_IN_KEY, enabled);
    setIsEnabled(enabled);
  }, []);
  const value = useMemo(
    () => ({ isEnabled, setEnabled }),
    [isEnabled, setEnabled]
  );

  return (
    <AtlasHomeOptInContext.Provider value={value}>
      {children}
    </AtlasHomeOptInContext.Provider>
  );
};

export const useHasUserEnabledAtlasHome = (): AtlasHomeOptInContextValue => {
  const context = useContext(AtlasHomeOptInContext);
  if (!context) {
    throw new Error(
      'useHasUserEnabledAtlasHome must be used within an AtlasHomeOptInProvider'
    );
  }
  return context;
};
